// extracted by mini-css-extract-plugin
module.exports = {"Spinner":"Spinner_Spinner__BWqNs","SpinnerDot":"Spinner_SpinnerDot__oZobt","SpinnerDot-before":"Spinner_SpinnerDot-before__1i7Ns"};